class CustomTabs extends HTMLElement {
    constructor() {
        super();
        this.previousScreenWidth = window.innerWidth;
    }

    // listen for the resize and DOMContentLoaded events
    connectedCallback() {
        this.details = this.querySelectorAll('details');

        this.matchMediaHandler();

        window.addEventListener('resize', () => {
            const currentScreenWidth = window.innerWidth;
            if (currentScreenWidth !== this.previousScreenWidth) {
                this.previousScreenWidth = currentScreenWidth;
                this.matchMediaHandler();
            }
        });
    }

    // define a method to handle media queries
    matchMediaHandler() {
        if ("matchMedia" in window) {
            if (window.matchMedia("(min-width:1024px)").matches) {
                for (let i = 0; i < this.details.length; i++) {
                    this.details[i].setAttribute("open", "open");
                }
            } else {
                for (let i = 0; i < this.details.length; i++) {
                    this.details[i].removeAttribute("open");
                }
            }
        }
    }
}

customElements.define('custom-tabs', CustomTabs);
